import DynamicIcon from '../DynamicIcon';
import { format } from 'date-fns';

export default function SystemServicesView({ 
    servicesArray, 
    headerBgColor, 
    headerTextColor, 
    rowLightBgColor, 
    rowLightTextColor,
    rowDarkBgColor,
    rowDarkTextColor,
    highlightBgColor,
    highlightTextColor
}) {
    const dateformat = "dd/MM/yyyy";
    return (
        <table className="w-full table-fixed text-xs border-collapse">
            <thead>
                <tr 
                    style={{
                        backgroundColor: headerBgColor || '#f5f5f5',
                        color: headerTextColor || '#333333',
                    }}
                >
                    <th className="w-[40px] p-2 text-center font-medium">#</th>
                    <th className="w-1/3 p-2 text-center font-medium">Tipo Impianto</th>
                    <th className="w-1/3 p-2 text-center font-medium">Data collaudo</th>
                    <th className="w-1/3 p-2 text-center font-medium">Data scadenza garanzia</th>
                </tr>
            </thead>
            <tbody>
                {
                    servicesArray && servicesArray.map((service, index) => (
                        <tr 
                            key={index} 
                            style={{
                                backgroundColor: index % 2 === 0 ? (rowLightBgColor || '#ffffff') : (rowDarkBgColor || '#f9f9f9'),
                                color: index % 2 === 0 ? (rowLightTextColor || '#333333') : (rowDarkTextColor || '#333333'),
                            }}
                            className="border-t border-gray-200 hover:transition-colors hover:duration-150"
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = highlightBgColor || '#f0f0f0';
                                e.currentTarget.style.color = highlightTextColor || '#000000';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = index % 2 === 0 ? 
                                    (rowLightBgColor || '#ffffff') : (rowDarkBgColor || '#f9f9f9');
                                e.currentTarget.style.color = index % 2 === 0 ? 
                                    (rowLightTextColor || '#333333') : (rowDarkTextColor || '#333333');
                            }}
                        >
                            <td className="w-[40px] p-2 text-center">{index + 1}</td>
                            <td className="w-1/3 p-2 text-center">{service.typeLabel}</td>
                            <td className="w-1/3 p-2 text-center">{service.testedDate ? format(new Date(service.testedDate), dateformat) : '-'}</td>
                            <td className="w-1/3 p-2 text-center">{service.expirationWarrantyDate ? format(new Date(service.expirationWarrantyDate), dateformat) : '-'}</td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
    );
}